"use strict";

const recipeTemplate = module.exports = recipe => {
  let metadata = {
    icon: recipe.icon,
    sortOrder: recipe.sortOrder,
    tags: recipe.tags,
    keywords: recipe.keywords,
    hidden: recipe.hidden,
    relatedRecipes: recipe.relatedRecipes,
    summary: recipe.summary,
  }
  return `
<!--METADATA
${JSON.stringify(metadata, null, 2)}
-->

# ${recipe.title}
${recipe.description || ''}

${recipe.steps.map(stepTemplate).join('\n\n')}

${!recipe.finishText ? '' : '## Finish\n' + recipe.finishText}

  `.trim();
}

const stepTemplate = step => `
## ${step.title}
${!step.description ? '' : typeof step.description === 'string' ? step.description : step.description.join('\n\n')}

${apiCallTemplate(step.apiCall, step.parameters || (step.apiCall || {}).parameters, step.ignoreParameters || (step.apiCall || {}).ignoreParameters)}
${codeSnippetTemplate(step.codeSnippet)}
${demoTemplate(step.demoHTML)}
`.trim();

const apiCallTemplate = (apiCall, parameters=null, ignoreParameters=null) => {
  if (!apiCall && !parameters) return '';
  let newObj = {};
  if (apiCall) newObj = {method: apiCall.method, path: apiCall.path};
  if (parameters) newObj.parameters = parameters;
  if (ignoreParameters) newObj.ignoreParameters = ignoreParameters;
  return `
### API Call
\`\`\`json
${JSON.stringify(newObj, null, 2)}
\`\`\`
`.trim();
}

const LANG_HIGHLIGHT_NAMES = {
  'node': 'javascript',
  'php53': 'php',
  'angular': 'typescript',
  'python': 'py',
  'ajax': 'javascript',
  'curl': 'bash',
}

const codeSnippetTemplate = snippets => {
  if (!snippets) return '';
  return Object.keys(snippets).map(lang => `
### Sample Code (${lang})
\`\`\`${LANG_HIGHLIGHT_NAMES[lang] || lang}
${snippets[lang]}
\`\`\`
  `.trim()).join('\n');
}

const demoTemplate = html => {
  if (!html) return '';
  html = html.replace(/\r/g, '').replace(/\t/g, '  ');
  return `
### Demo
\`\`\`html
${html}
\`\`\`
  `.trim();
}




// WEBPACK FOOTER //
// ./src/lib/recipe-to-markdown.js